<template>
    <header class="o-section__header o-section__header--inline">
        <h2 class="o-section__heading">Playlist</h2>
        <div class="o-form__field">
            <label class="o-form__label o-form__label--select" for="select-channel">
                <select class="o-form__select" id="select-channel" v-model="channel">
                    <option v-for="channel in channels" :key="channel.id" v-bind:value="channel.id">{{channel.name}}</option>
                </select>
            </label>
        </div>
        <div class="o-form__field">
            <label class="o-form__label o-form__label--select" for="select-date">
                <select class="o-form__select" id="select-date" v-model="currentDate">
                    <option v-for="item in dateRanges" :key="item.name" v-bind:value="item">{{item.name}}</option>
                </select>
            </label>
        </div>
    </header>
</template>

<script>
import { format, subDays, endOfDay } from 'date-fns'
import { nl } from 'date-fns/locale'
import { mapState } from 'vuex';

const now = new Date();
const dateRanges = Array.from({ length: 7 }, (value, idx) => {
  const date = subDays(now, idx)

  if (idx === 0) {
    return {name: 'vandaag', date: now}
  } else if (idx === 1) {
    return {name: 'gisteren', date: endOfDay(date)}
  } else {
    return {name: format(date, 'EEEE', {locale: nl}), date: endOfDay(date)}
  }
});

export default {
  name: 'Channels',
  data() {
    return {
      dateRanges,
      currentDate: dateRanges[0]
    }
  },
  computed: {
    channel: {
      get() { return this.$store.state.playlist.channel },
      set(value) {
        this.$store.dispatch('playlist/setChannel', value);
        this.currentDate = dateRanges[0]
      }
    },
    ...mapState({
      channels: state => state.channels.channels
    }),
  },
  watch: {
    currentDate() {
      this.$store.dispatch('playlist/setDate', this.currentDate.date)
    }
  },
};
</script>
